<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane label="版权方确权进度" name="first">
      <cp-confirm-table @go-match="handleGoMatch"></cp-confirm-table>
    </el-tab-pane>
    <el-tab-pane label="具体歌曲确权进度" name="second" lazy>
      <track-confirm-table :sub-order="subApplicationOrder"></track-confirm-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import CpConfirmTable from './components/CpConfirmTable.vue'
import TrackConfirmTable from './components/TrackConfirmTable.vue'

export default {
  name: 'MatchMod',
  components: {
    CpConfirmTable,
    TrackConfirmTable
  },
  data() {
    return {
      activeName: 'first',
      subApplicationOrder: ''
    }
  },
  methods: {
    handleGoMatch(subApplicationOrder) {
      this.subApplicationOrder = subApplicationOrder
      this.activeName = 'second'
    }
  }
}
</script>
